export default __webpack_public_path__ + "static/media/avatar_2.8b4ba1b3.png";